<template>
    <div class="content">
        <div class="title">证书查询</div>
        <div class="list">
            <div class="single" @click="go(0)">
                <img src="../../assets/cjcx.png">
                <div class="btn">成绩查询</div>
            </div>
            <div class="single" @click="go(1)">
                <img src="../../assets/zscx.png">
                <div class="btn">证书查询</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            
        }
    },
    methods: {
        go(index){
            switch(index){
                case 0:
                    this.$router.push('/cjs');
                    break;
                case 1:
                    this.$router.push('/zss');
                    break;
            }
        }
    },
}
</script>
<style lang="scss" scoped>
.content{
    width:1120px;
    margin:auto;
    box-sizing: border-box;
    padding: 30px;
    background: #fff;
    .title{
        font-size: 22px;
        color: #235483;
        letter-spacing: 0.62px;
        font-weight: 600;
    }
    .list{
        width:100%;
        display: flex;
        margin-top: 25px;
        .single{
            width:240px;
            margin-right:30px;
            cursor: pointer;
            display: flex;
            flex-direction: column;
            img{
                width:100%;
                height:130px;
            }
            .btn{
                width:100%;
                height:60px;
                line-height: 60px;
                background: #F0F0F0;
                text-align: center;
                font-family: PingFangSC-Semibold;
                font-size: 16px;
                color: #333333;
                letter-spacing: 0.45px;
                font-weight: 600;
            }
        }
    }
}
</style>
